// Imports ------------------------------------------------------------------->

// Private Definitions ------------------------------------------------------->

type GLContext = WebGLRenderingContext | CanvasRenderingContext2D

let initialGetContextCall = true
let cachedWebGLContext: GLContext = null

// Public Definitions -------------------------------------------------------->

export function isWebglEnabled() {
    if (initialGetContextCall) {
        const canvas = document.createElement('canvas')
        cachedWebGLContext =
            (canvas.getContext('webgl') as any) ||
            (canvas.getContext('experimental-webgl') as any)
        initialGetContextCall = false
    }

    if (
        cachedWebGLContext &&
        cachedWebGLContext instanceof WebGLRenderingContext
    ) {
        return true
    } else {
        return false
    }
}

export function getWebglContext(
    canvas: HTMLCanvasElement,
    contextOptions: any
) {
    if (!canvas) {
        return null
    }

    const gl =
        canvas.getContext('webgl', contextOptions) ||
        canvas.getContext('experimental-webgl', contextOptions)

    if (gl && gl instanceof WebGLRenderingContext) {
        return gl
    }

    return null
}
